// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import SortDownSvg from '@rsuite/icon-font/lib/direction/SortDown';
var SortDown = createSvgIcon({
  as: SortDownSvg,
  ariaLabel: 'sort down',
  category: 'direction',
  displayName: 'SortDown'
});
export default SortDown;